import { render } from "./MyAnnouncements.vue?vue&type=template&id=2ba27202"
import script from "./MyAnnouncements.vue?vue&type=script&lang=js"
export * from "./MyAnnouncements.vue?vue&type=script&lang=js"

import "./MyAnnouncements.vue?vue&type=style&index=0&id=2ba27202&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__